export default "__VITE_ASSET__AqI0TYgB__"